module.exports = __webpack_public_path__ + "img/carne-header-ap3.38b5dd76.png";